export const DEVICE_MENU_CATEGORIES = [
  { key: 'phones', publicPath: 'puhelimet' },
  { key: 'android', publicPath: 'android-puhelimet' },
  { key: 'ios', publicPath: 'apple-puhelimet' },
  { key: 'accessories', publicPath: 'lisatarvikkeet-puhelimet' },
  { key: 'otherPhones', publicPath: 'muut-puhelimet' },
] as const;

export type DeviceCategoryKey = (typeof DEVICE_MENU_CATEGORIES)[number]['key'];

const DEVICE_CATEGORY_KEYS = new Set<string>(DEVICE_MENU_CATEGORIES.map(category => category.key));

export const isDeviceCategoryKey = (value: string): value is DeviceCategoryKey => DEVICE_CATEGORY_KEYS.has(value);

export interface DeviceMenuCategory {
  key: DeviceCategoryKey;
  publicPath: string;
}
